/*****************************************************
Naam: DashboardHeader.jsx
Locatie: src/components/Dashboard/DashboardHeader.jsx
Datum: 2026-02-07
Versie: 1.0.0
******************************************************
Beschrijving:
Header component met logo en achtergrond.
******************************************************/

import React from 'react';

const DashboardHeader = ({ companyLogo, backgroundLogo }) => {
  return (
    <>
      {/* Achtergrond logo */}
      {backgroundLogo && (
        <div 
          className="absolute inset-0 bg-center bg-no-repeat bg-contain"
          style={{
            backgroundImage: `url(${backgroundLogo})`,
            opacity: 0.1,
            zIndex: 0
          }}
        />
      )}
      
      {/* Logo at top right */}
      <div className="absolute top-6 right-6">
        {companyLogo ? (
          <div className="bg-white/10 backdrop-blur-sm p-4 border-2 border-white/20">
            <img 
              src={companyLogo} 
              alt="Company Logo" 
              className="h-16 object-contain"
            />
          </div>
        ) : (
          <div className="bg-white/10 backdrop-blur-sm p-6 border-2 border-white/20">
            <div className="text-white font-bold text-2xl">LOGO</div>
          </div>
        )}
      </div>
    </>
  );
};

export default DashboardHeader;
